export default "__VITE_ASSET__PjcZ3oZG__"